import React, { useEffect, useState } from "react";

const CountdownTimer = ({
  startTime,
  classNew = "",
  isHours,
  isMinutes,
  isSeconds,
}) => {
  const calculateTimeLeft = () => {
    const now = Date.now();
    const difference = startTime - now;

    if (difference <= 0) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    const hours = Math.floor(difference / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return { hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTime = calculateTimeLeft();
      setTimeLeft(updatedTime);

      if (
        updatedTime.hours === 0 &&
        updatedTime.minutes === 0 &&
        updatedTime.seconds === 0
      ) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  const { hours, minutes, seconds } = timeLeft;

  return (
    <div className={classNew}>
      {hours === 0 && minutes === 0 && seconds === 0 ? (
        <span>00:00</span>
      ) : (
        <span>
          {isHours && hours > 0 && `${String(hours).padStart(2, "0")}h:`}
          {isMinutes && `${String(minutes).padStart(2, "0")}m:`}
          {isSeconds && `${String(seconds).padStart(2, "0")}s`}
        </span>
      )}
    </div>
  );
};

export const RunningSinceTimer = ({ startTimestamp }) => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const updateElapsed = () => {
      const now = Date.now();
      const diffMs = now - new Date(startTimestamp).getTime();
      setElapsed(Math.floor(diffMs / 1000)); // store in seconds
    };

    updateElapsed(); // initial call
    const interval = setInterval(updateElapsed, 1000);

    return () => clearInterval(interval); // cleanup
  }, [startTimestamp]);

  // Format seconds into HH:MM:SS
  const formatTime = (totalSeconds) => {
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${hours > 0 ? hours + "h:" : ""}${minutes}m:${seconds}s`;
  };

  return <span>{formatTime(elapsed)}</span>;
};

export const CountdownTimerUsingSeconds = ({ endTimeseconds }) => {
  const [seconds, setSeconds] = useState(endTimeseconds);

  useEffect(() => {
    if (seconds <= 0) return;

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  const formatTime = (secs) => {
    const hrs = String(Math.floor(secs / 3600) || 0).padStart(2, "0");
    const mins = String(Math.floor((secs % 3600) / 60) || 0).padStart(2, "0");
    const secsLeft = String(secs % 60 || 0).padStart(2, "0") || 0;

    return `${hrs > 0 ? hrs + "h:" : ""}${mins}m:${String(secsLeft)}s`;
  };

  return <div>{formatTime(seconds)}</div>;
};

export default CountdownTimer;
